import { Component, OnInit } from '@angular/core';
import { IonItem, IonContent } from "@ionic/angular/standalone";
import { IonPopover, IonicModule } from '@ionic/angular';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserInfoService } from 'src/app/services/user-info.service';
import { addIcons } from 'ionicons';
import { informationCircleOutline, arrowForwardOutline } from 'ionicons/icons';
import { DataService } from 'src/app/services/data-api.service';
import { catchError, map, Observable, of } from 'rxjs';
import { UserNotificationComponent } from '../../shared/user-notification/user-notification.component';
import { UserNotificationService } from 'src/app/services/user-notification.service';
import { ForgotPasswordRequest, ForgotPasswordResponse, UserNotificationViewModel } from 'src/app/models/viewmodels';
import { ValidatorsHelper } from '../../util/validators-helper';
import { ErrorMessagesComponent } from 'src/app/components/util/error-messages/error-messages.component';

@Component({
  standalone: true,
  selector: 'app-user-forgot-password',
  templateUrl: './user-forgot-password.component.html',
  styleUrls: ['./user-forgot-password.component.scss'],
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    UserNotificationComponent,
    ErrorMessagesComponent,
  ],
})
export class UserForgotPasswordComponent implements OnInit {
  userForgotPasswordForm: FormGroup = new FormGroup({});
  showUserNotification: boolean = false;
  userNotification: UserNotificationViewModel = {};

  validationParameters = {
    username: [
      { type: 'required', message: 'Email field is required' },
      { type: 'email', message: 'Enter a valid email' },
      { type: 'emailExists', message: "Email doesn't exist" },
    ],
  };
  email: string = '';
  logoImagePath: string = '';

  constructor(
    private fb: FormBuilder,
    private userInfoService: UserInfoService,
    private dataService: DataService,
    private userNotificationService: UserNotificationService,
  ) {
    this.userForgotPasswordForm = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.email],
        [this.validateEmail()],
      ],
    });
    this.userNotificationService.userNotification$.subscribe((notification) => {
      this.userNotification = notification;
    });

    addIcons({
      arrowForwardOutline
    });
  }
  validateEmail(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }

      return this.dataService.userExistsByEmail(control.value).pipe(
        map((res) => (!res ? { emailExists: true } : null)),
        catchError(() => of(null)),
      );
    };
  }
  validateEmailExists = ValidatorsHelper.validateEmailExists;
  isRequiredField = ValidatorsHelper.isRequired;
  isNotEqualTo = ValidatorsHelper.isNotEqualTo;
  passwordMatchValidator = ValidatorsHelper.passwordMatchValidator;
  
  async ngOnInit() {
    // await this.userInfoService.getLogoImageUrlAsync().then((imageUrl: any) => {
    //   this.logoImagePath = imageUrl;
    // });
    // this.logoImagePath = "/assets/images/QuotifyLogoImage.png";
    try {
      let isEngineerUrl =
        window.location.href.toLowerCase().includes('specifymanagerpro.com') ||
        window.location.href.toLowerCase().includes('localhost:8123');
      if (isEngineerUrl) {
        this.logoImagePath = '/assets/images/SpecifyManagerLogo.png';
      } else {
        this.logoImagePath = '/assets/images/QuotifyLogoImage.png';
      }
    } catch (error) {
      console.error(
        'user-login',
        'ngOnInit',
        'error getting logo image path',
        error,
      );
    }
  }

  onSubmitForm() {
    this.userForgotPasswordForm.markAllAsTouched();

    if (this.userForgotPasswordForm.valid) {
      var email: string = this.userForgotPasswordForm.get('email').value;
      let emailRequestModel: ForgotPasswordRequest = { email: email };
      this.dataService
        .forgotPassword(emailRequestModel)
        .subscribe((res: ForgotPasswordResponse) => {
          if (res.success) {
            this.showUserNotification = true;
            let notification: UserNotificationViewModel = {
              'Title': 'Success',
              'SubTitle': 'Forgot Password Confimation',
              'Notification': `Thanks, a confirmation email has been sent to ${email}. Please follow up to continue `,
              'NotificationType': 'success',
            };
            this.userNotificationService.showUserNotification(notification);
          } else {
            this.showUserNotification = true;
            let notification: UserNotificationViewModel = {
              'Title': 'Error',
              'SubTitle': 'Forgot Password Confirmation Failed',
              'Notification': res.failureMsg,
              'NotificationType': 'error',
            };
            this.userNotificationService.showUserNotification(notification);
          }

          //hkombem@firstco.com
        });
    }
  }
  onCancel() {
    window.location.href = '/user/user-login';
  }
  onUserNotificationClose() {
    this.showUserNotification = false;
  }
}
